module.exports = __webpack_public_path__ + "img/104.a0569835.svg";